import { HttpResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { PasajerosService } from 'src/app/_services/pasajeros.service';
import { AuxiliarService } from 'src/app/_services/auxiliar.service';

type Pasajero = {
    id: number;
    nombre_pasajero: string;
    tipo_documento: string;
    numero_documento: string;
    fecha_nacimiento: string;
    telefono_pasajero: string;
    email_pasajero: string;
    observaciones_pasajero: string;
    destino: string;
    fecha: string;
    precio: string;
    pagado: number;
    costo_total: number;
}

@Component({
  selector: 'app-modal-pasajeros-detalles',
  templateUrl: './modal-pasajeros-detalles.component.html',
  styleUrls: ['./modal-pasajeros-detalles.component.css']
})
export class ModalPasajerosDetallesComponent implements OnInit {
  pasajero: Pasajero;
  form: FormGroup;
  precio_total: Number;

  constructor(
    public activeModal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private pasajerosService: PasajerosService,
    private auxService:AuxiliarService,
  ) { }

  ngOnInit(): void {
    var fecha = this.pasajero.fecha_nacimiento ?
                           (new Date(this.pasajero.fecha_nacimiento)) :
                           null;
    var fecha_nacimiento = this.isValidDate(fecha)
                           ? fecha.toJSON().split('T')[0]
                           : fecha_nacimiento = null;

    this.form = this.formBuilder.group({
      nombre: [this.pasajero.nombre_pasajero, Validators.required],
      tipodoc: [this.pasajero.tipo_documento, Validators.required],
      documento: [this.pasajero.numero_documento, Validators.required],
      fechanacimiento: [fecha_nacimiento],
      telefono: [this.pasajero.telefono_pasajero, Validators.required],
      email: [this.pasajero.email_pasajero, Validators.required],
      pagado: [this.pasajero.pagado, Validators.required],
    }, { });
    // }, { validators: this.rangoCategoria()});

    var costo_total = this.pasajero.costo_total;
    var precio = parseInt(this.pasajero.precio);
    this.precio_total = costo_total > 0 ? costo_total : precio;


    (<HTMLInputElement>document.getElementById("fecha-viaje")).value = this.formatoFecha(this.pasajero.fecha);
    (<HTMLInputElement>document.getElementById("destino-viaje")).value = this.pasajero.destino;
    (<HTMLInputElement>document.getElementById("precio-total")).value = this.pasajero.costo_total.toString();
    this.setDebe(this.pasajero.pagado);
    this.setEstadoCuenta(this.pasajero.pagado);

    this.form.get("pagado").valueChanges.subscribe(selectedValue => {
      this.setDebe(selectedValue);
      this.setEstadoCuenta(selectedValue);
    });
  }

  isValidDate(d) {
    return (Object.prototype.toString.call(d) === '[object Date]') && isFinite(d);
  }

  formatoFecha(fecha){
    if(fecha !== null && fecha !== undefined){
      var fe = fecha.split("T")[0].split("-");
      return fe[2]+"/"+fe[1]+"/"+fe[0];
    } else
      return "";
  }

  setDebe(pagado){
    var debe = (this.precio_total as number) - parseInt(pagado);
    (<HTMLInputElement>document.getElementById("debe")).value = !Number.isNaN(debe) ? debe.toString(): this.pasajero.precio;
  }

  setEstadoCuenta(pagado){
    var estado;
    if(pagado == 0){
      estado = "Sin Pago";
    } else if (pagado == this.precio_total) {
      estado = "Pago Total";
    } else if (pagado > 0 && pagado < this.precio_total) {
      estado = "Pago Parcial";
    } else if (pagado < 0) {
      estado = "Error Pago Negativo";
    } else {
      estado = "Error Pago Excedido";
    };

    (<HTMLInputElement>document.getElementById("estado-cuenta")).value = estado;
  }
  // rangoCategoria(){
  //   return (formGroup: FormGroup) => {
  //     const control = formGroup.controls['categoria'];
  //     if ( (control.value < '1' ||  control.value > '5') &&  control.value !== '') {
  //         control.setErrors({ rangoCategoria: true });
  //     }
  //   }
  // }
  get f() { return this.form.controls; }

  onSubmit(){
    // stop here if form is invalid
    if (this.form.invalid) {
        return;
    }
    var that = this;
    console.log(this.f.fechanacimiento.value);
    this.pasajerosService.pasajeroUpdateDetalles(this.pasajero.id, this.f.nombre.value, this.f.telefono.value, this.f.email.value, this.f.tipodoc.value,
                                         this.f.documento.value, this.f.pagado.value, this.f.fechanacimiento.value).subscribe(data => {
      if(data instanceof HttpResponse) {
        //verificar token
        if(data.body.msg === 'TOKEN_INVALID' || data.body.msg === 'TOKEN_IS_NOT_FOUND') {
          this.auxService.sessionExpired();
        }
        that.activeModal.close();
      }
    });
  }

}
